import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { TextField } from 'redux-form-material-ui';

import brCurrencyMask from '../../utils/masks/brCurrencyMask';

const BrCurrencyRangeFilter = ({ name, title }) => (
  <FormControl>
    <FormLabel>{title}</FormLabel>
    <Field name={`${name}.minValue`} label="Mínimo" component={TextField} {...brCurrencyMask} />
    <Field name={`${name}.maxValue`} label="Máximo" component={TextField} {...brCurrencyMask} />
  </FormControl>
);

BrCurrencyRangeFilter.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default BrCurrencyRangeFilter;
